<template>
    <div id="warp" :style="{ paddingTop: paddingTop + 'px' }">
        <div class="heade" ref="heade">
            <div class="heade_1">
                <div class="omjs-wrapper">
                    <ComHeaderTime />
                    <div>
                        <div class="headerConfiguration">
                            <ul style="display:flex;">
                                <li v-for="(item, index) in headerList" :key="index" @click="jump(item)">
                                    <i v-show="item.hotStatus" :style="'background-image:url(' +
                                        $common.getImgUrl(item.hotPic) +
                                        ')'
                                        "></i>
                                    <span :style="{
                                            color: `${flashing && item.shineStatus
                                                ? item.shineColor
                                                : item.bottomColor
                                                }`,
                                        }">{{ item.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="{ navChange: true, small }">
                <ul class="nav">
                    <li class="logo">
                        <router-link to="/home">
                            <img loading="lazy" :src="$common.getTitleLogo('logo')" alt />
                        </router-link>
                        <div class="popup-list">
                            <div class="popup-top"></div>
                            <div class="popup-cont">
                                <div class="popup-item" @click="gotoRegister()">
                                    <div class="popup-icon"></div>
                                    <span>免费注册</span>
                                </div>
                                <div class="popup-item fs" @click="logoGo(2)">
                                    <div class="popup-icon"></div>
                                    <span>时时返水</span>
                                </div>
                                <div class="popup-item zq" @click="logoGo(3)">
                                    <div class="popup-icon"></div>
                                    <span>活动专区</span>
                                </div>
                                <div class="popup-item lr" @click="logoGo(4)">
                                    <div class="popup-icon"></div>
                                    <span>代理加盟</span>
                                </div>
                                <div class="popup-item kf" @click="logoGo(5)">
                                    <div class="popup-icon"></div>
                                    <span>在线客服</span>
                                </div>
                                <div class="popup-item xz" @click="logoGo(6)">
                                    <div class="popup-icon"></div>
                                    <span>APP下载</span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- 电子游艺 -->
                    <li :class="{ street_game: true, active: activeIndex == 2 }" @click="toPage(2)">
                        <el-popover placement="bottom" trigger="hover" popper-class="popover">
                            <top-game-menu-list :type="1" :size="2" :list="list_dz"></top-game-menu-list>
                            <div slot="reference"
                                :style="{ color: `${platReg === 'qxyl' ? '#fde9aa' : (flashing ? shineNom : shineRed)}` }">
                                <router-link to="/egame">
                                    <!-- 电游街机 -->
                                    {{ $t("warp.egame") }}
                                </router-link>
                            </div>
                        </el-popover>
                    </li>
                    <!-- 真人 -->
                    <li @click="toPage(1)" :class="{ real: true, active: activeIndex == 1 }">
                        <el-popover placement="bottom" trigger="hover" popper-class="popover" :offset="3000">
                            <top-game-menu-list :type="3" :size="1" :default="4" :list="list_zb"></top-game-menu-list>
                            <div slot="reference"
                                :style="{ color: `${platReg !== 'qxyl' ? '#fde9aa' : (flashing ? shineNom : '#56ff5e')}` }">
                                <span>
                                    <!-- 真人 -->
                                    {{ $t("warp.live") }}
                                </span>
                            </div>
                        </el-popover>
                    </li>
                    <!-- 棋牌 -->
                    <li :class="{ cards: true, active: activeIndex == 4 }" @click="toPage(4)">
                        <el-popover placement="bottom" trigger="hover" popper-class="popover">
                            <top-game-menu-list :type="2" :size="4" :default="0" :list="list_qp"></top-game-menu-list>
                            <div slot="reference"
                                :style="{ color: `${platReg === 'qxyl' ? '#fde9aa' : (flashing ? shineNom : shineRed)}` }">
                                <span>
                                    <!-- 棋牌 -->
                                    {{ $t("warp.chess") }}
                                </span>
                            </div>
                        </el-popover>
                    </li>
                    <!-- 捕鱼 -->
                    <li @click="toPage(6)" :class="{ sports: true, active: activeIndex == 6 }">
                        <el-popover placement="bottom" trigger="hover" popper-class="popover">
                            <top-game-menu-list :type="4" :size="6" :list="list_by"></top-game-menu-list>
                            <div slot="reference"
                                :style="{ color: `${platReg === 'qxyl' ? (flashing ? shineNom : '#f947f3') : (flashing ? shineNom : shineRed)}` }">
                                <span>
                                    <!-- 捕鱼 -->
                                    {{ $t("warp.fish") }}
                                </span>
                            </div>
                        </el-popover>
                    </li>
                    <!-- 体育 -->
                    <li :class="{ fish: true, active: activeIndex == 3 }" @click="toPage(3)">
                        <el-popover placement="bottom" trigger="hover" popper-class="popover">
                            <top-game-menu-list :type="3" :size="3" :default="3" :list="list_tydj"></top-game-menu-list>
                            <div slot="reference">
                                <!-- 体育/电竞 -->
                                {{ $t("warp.sport") }}
                            </div>
                        </el-popover>
                    </li>

                    <!-- 彩票 -->
                    <li @click="toPage(5)" :class="{ sports: true, active: activeIndex == 5 }">
                        <el-popover placement="bottom" trigger="hover" popper-class="popover">
                            <top-game-menu-list :type="3" :size="5" :default="1" :list="list_cp"></top-game-menu-list>
                            <div slot="reference"
                                :style="{ color: `${platReg !== 'qxyl' ? '#fde9aa' : (flashing ? shineNom : '#2799f1')}` }">
                                <span>
                                    {{ $t("warp.lottery") }}
                                </span>
                            </div>
                        </el-popover>
                    </li>

                    <li @click="toPage(7)" :class="{ discount: true, active: activeIndex == 7 }">
                        {{ $t("warp.discount") }}
                    </li>
                    <li @click="toPage(8)"
                        :style="{ color: `${platReg !== 'qxyl' ? '#fde9aa' : (flashing ? shineNom : '#56ff5e')}` }">
                        {{ $t("warp.service") }}
                    </li>
                    <!-- 合作专区 -->
                    <!-- <li
                        @click="toPage(9)"
                        :class="{ active: activeIndex == 9 }"
                    >
                        <i></i>
                        
                        {{ $t("warp.cooperation") }}
                        <div class="line"></div>
                    </li>-->
                    <!-- <li v-show="$common.getUser()">
                        <search-item></search-item>
                    </li> -->

                    <!-- <li class="login_nav" v-if="small && !isLogin">
                        <span @click="gotoLogin()">{{ $t("loginPage.login") }}</span>
                    </li>
                    <li class="register" v-if="small && !isLogin">
                        <span @click="gotoRegister()">{{ $t("registerPage.register") }}</span>
                    </li> -->

                    <!-- <li class="smallRight" v-if="small && isLogin">
                        <div @click="openUrl('/my/finance/deposit')">{{ $t("header.text1") }}</div>
                        <span>|</span>
                        <div @click="openUrl('/my/finance/withdraw')">{{ $t("header.text2") }}</div> -->
                    <!-- <span>|</span>
                        <div>自助</div>-->
                    <!-- </li> -->
                </ul>
            </div>
            <!-- 未登录 -->
            <div class="heade_1 new-login">
                <div class="omjs-wrapper">
                    <!-- <div class="fly-light"></div> -->
                    <div class="login-text">会员登录LOGIN</div>
                    <ul class="nav">
                        <div style="display: flex">
                            <div v-if="!isLogin" class="headerRight">
                                <LoginNew />
                                <!-- <li class="login_nav">
                                    <span @click="gotoLogin()">{{ $t("loginPage.memberLogin") }}</span>
                                </li>
                                <li class="register">
                                    <span @click="gotoRegister()">{{ $t("warp.memberRegister") }}</span>
                                </li> -->
                            </div>
                            <div v-if="isLogin" class="headerRight">
                                <router-link :to="{ path: '/app', query: { index: 0 } }" class="icon">
                                    <li class="icon">
                                        <i class="icon1"></i>APP
                                    </li>
                                </router-link>
                                <!-- <li class="line"></li> -->
                                <!-- <router-link
                                    :to="{ path: '/download', query: { index: 1 } }"
                                    class="icon"
                                >
                                    <li class="icon">
                                        <i class="icon2"></i>
                                        电脑版
                                        {{ $t("warp.pc") }}
                                    </li>
                                </router-link> -->
                                <li class="line"></li>

                                <li class="name">
                                    <router-link to="/my/info/basic">
                                        <!-- 你好, -->
                                        {{ $t("warp.hello") }},
                                        <el-tooltip effect="dark" :content="$store.state.userInfo.name"
                                            placement="top-start">
                                            <u class="red">{{ $store.state.userInfo.name }}</u>
                                        </el-tooltip>
                                    </router-link>
                                </li>
                                <li class="balance">
                                    <!-- 余额 -->
                                    {{ $t("warp.balance") }}
                                    :
                                    {{
                                        filterNumber(
                                            $store.state.userInfo.totalBalance
                                        )
                                    }}
                                    <i @click="getGameMoneyList(true)" :class="{ shuaActive: refreshImgStart }"></i>
                                </li>
                                <li class="line"></li>
                                <li class="dropdown">
                                    <el-dropdown size="medium" placement="bottom">
                                        <span class="el-dropdown-link">
                                            <!-- 资金 -->
                                            {{ $t("warp.money") }}
                                            <i></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown" id="warp" style="background: #0b0c13">
                                            <el-dropdown-item @click.native="toDeposit('/my/finance/deposit')
                                                ">{{ $t("warp.memberDeposit") }}</el-dropdown-item>
                                            <el-dropdown-item @click.native="toDeposit(
                                                '/my/finance/withdraw'
                                            )
                                                ">{{ $t("warp.memberWithdraw") }}</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </li>
                                <li class="line"></li>

                                <!-- <li class="dropdown" v-show="preferentialList" @click="toSelfHelp()">
                                    <el-dropdown size="medium" placement="bottom">
                                        <span class="el-dropdown-link">
                                            自助
                                            {{ $t("warp.selfHelp") }}
                                            <i></i>
                                        </span>
                                        <el-dropdown-menu
                                            slot="dropdown"
                                            id="warp"
                                            style="background: #0b0c13"
                                        >
                                            <el-dropdown-item
                                                v-for="(item,index) in preferentialList"
                                                :key="index"
                                                @click.native="toPreferential(item)"
                                            >{{item.name}}</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </li>
                                <li class="line" v-show="preferentialList"></li> -->

                                <li>
                                    <router-link to="/my/service/mail">
                                        <!-- 站内信 -->
                                        {{ $t("warp.message") }}
                                    </router-link>
                                </li>

                                <!-- <li class="sign" @click="openShop(true)">
                                    <span>
                                        签到
                                        {{ $t("warp.sign") }}
                                    </span>
                                </li> -->

                                <li @click="logout()">
                                    <!-- 退出 -->
                                    {{ $t("warp.logout") }}
                                </li>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        </div>

        <router-view ref="openSignin"></router-view>

        <!-- 底部 -->
        <div id="footer">
            <div class="footer-top" v-if="platReg === 'amjs' || platReg === 'bmyl'">
                <div class="amjs-wrapper">
                    <ul class="footer-info">
                        <li v-if="platReg === 'amjs'" class="tel">
                            官方热线
                            <span>0063-9695-600000</span>
                        </li>
                        <li class="mail">
                            投诉邮箱
                            <span v-if="platReg === 'bmyl'">bmyl011926@gmail.com</span>
                            <span v-if="platReg === 'amjs'">cs@sanos8888.com</span>
                        </li>
                        <li class="mail">
                            代理咨询
                            <span v-if="platReg === 'bmyl'">QQ：717544932</span>
                            <span v-if="platReg === 'amjs'">QQ：1579010</span>
                        </li>
                        <li class="service" @click="logoGo(5)">
                            7X24小时 在线客服
                            <span>Online Service</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="amjs-wrapper">
                    <div class="footer-logo"></div>
                    <ul class="footer-nav">
                        <li><a @click="footerTrans(0)">关于我们</a></li>
                        <li><a @click="footerTrans(5)">联系我们</a></li>
                        <li><a @click="footerTrans(2)">规则与声明</a></li>
                        <li><a @click="footerTrans(4)">常见问题</a></li>
                        <li><a @click="footerTrans(7)">存款帮助</a></li>
                        <li><a @click="footerTrans(8)">取款帮助</a></li>
                        <li><a @click="logoGo(4)">代理加盟</a></li>
                    </ul>
                    <p class="footer-suggest">Copyright © {{ $t("titilName") }} Reserved</p>
                </div>
            </div>
        </div>
        <RightBarRt class="rightbar-right" :style="{ top: top_side + 'px' }" />
        <!-- <RightBar class="rightbar-right" :style="{top:top_side +'px'}" /> -->
        <!-- <rebate ref="refRebate" :userfan="userfan" @onbackFan="onbackFan"></rebate> -->
    </div>
</template>

<script>
// import "./warp.scss";
import { showLogin } from "../login/login.js";
import RightBarRt from "../rightBar/rightBarRt.vue";
import RightBar from "../rightBar/rightBar.vue";
import topGameMenuList from "./topGameMenuList.vue";
// import searchItem from "@/components/search/search";
import rebate from "../../components/Rebate/Rebate";
import ComHeaderTime from '../../components/ComHeaderTime'
import LoginNew from "../login/loginNew";

export default {
    components: {
        RightBarRt,
        RightBar,
        topGameMenuList,
        rebate,
        // searchItem,
        ComHeaderTime,
        LoginNew
    },
    data() {
        return {
            top_side: 120,
            numVer: window.numVer,
            fishItem: {},
            list_zb: [],
            list_dz: [],
            list_tydj: [],
            list_qp: [],
            list_cp: [],
            list_by: [],
            list_dj: [],
            headerList: [],
            language: "简体",
            flashing: false,
            activeIndex: 0,
            small: false,
            isLogin: false,
            dialogTableVisible: false,
            signinData: {},
            refreshImgTime: false,
            refreshImgStart: false,
            userfan: {},
            shopName: "",
            preferentialList: [],
            customerList: [],
            aygjUrl: '',
            shineRed: '#f01924',
            shineNom: '#fde9aa',
            platReg: '',
            paddingTop: 179
        };
    },
    created() {
        this.platReg = window.projectImgUrl;
        if (this.$store.state.token) {
            this.isLogin = true;
        }
        this.getGameMenuListData();
        // this.getList();
        setInterval(() => {
            this.flashing = true;
        }, 200);

        setInterval(() => {
            this.flashing = false;
        }, 400);
    },
    mounted() {
        const that = this
        MutationObserver = window.MutationObserver || window.webkitMutationObserver || window.MozMutationObserver;
        const mutationObserver = new MutationObserver(function (mutations) {
            that.paddingTop = that.$refs.heade.clientHeight
        })
        mutationObserver.observe(this.$refs.heade, {
            characterData: true, // 节点内容或节点文本的变动
            subtree: true, // 是否将观察器应用于该节点的所有后代节点
        })
        window.addEventListener("scroll", this.handleScroll);
        this.listQuickEntry();
        if (!this.$common.getLocale("locale")) {
            let lang = "zh_CN";
            lang = window.locale || "zh_CN";
            this.$i18n.locale = lang;
            switch (lang) {
                case "zh_CN":
                    this.language = "简体";
                    break;
                case "zh_HK":
                    this.language = "繁體";
                    break;
            }
            // this.value = lang === 'zh_CN'?'中文/简体':'中文/繁體';
            this.$common.setLocale(lang);
        } else {
            switch (this.$common.getLocale()) {
                case "zh_CN":
                    this.language = "简体";
                    break;
                case "zh_HK":
                    this.language = "繁體";
                    break;
            }
        }
        // this.getshopName();
    },
    methods: {
        toSelfHelp() {
            this.$router.push({
                path: "/my/discount"
            });
        },
        toPreferential(item) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            switch (item.type) {
                case 4:
                    this.$router.push({
                        path: "/my/discount/credentials",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 5:
                    this.$router.push({
                        path: "/my/discount/week",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 6:
                    this.$router.push({
                        path: "/my/discount/lucky",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 7:
                    this.$router.push({
                        path: "/my/discount/anniversary",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 8:
                    this.$router.push({
                        path: "/my/discount/Reward",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 9:
                    this.$router.push({
                        path: "/my/discount/Rescue",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 10:
                    this.$router.push({
                        path: "/my/discount/manyTimes",
                        query: {
                            id: item.id
                        }
                    });
                    break;
                case 11:
                    this.$router.push({
                        path: "/my/discount/feedback",
                        query: {
                            id: item.id
                        }
                    });
                    break;
            }
        },
        getList() {
            this.$http
                .post(this.$api.getThematicActivitiesListByApp, "")
                .then(res => {
                    if (res.code == 0) {
                        this.preferentialList = res.data.content;
                    }
                });
        },
        toDeposit(url) {
            this.$router.push(url);
        },
        footerTrans(val) {
            this.$router.push("/help?tab=" + val);
        },
        transgo() {
            this.$router.push("/");
        },
        listQuickEntry: async function () {
            const res = await this.$http.get(this.$api.listQuickEntry, false);
            if (res.code === 0 && res.data.length != 0) {
                res.data.sort((item1, item2) => {
                    return item1.sort - item2.sort;
                });
                this.headerList = res.data;
            }
        },
        selectLanguage() {
            switch (this.language) {
                case "简体":
                    this.$i18n.locale = "zh_HK";
                    this.$common.setLocale("zh_HK");
                    this.$config.local = "zh_HK";
                    this.language = "繁體";
                    break;
                case "繁體":
                    this.$i18n.locale = "zh_CN";
                    this.$common.setLocale("zh_CN");
                    this.$config.local = "zh_CN";
                    this.language = "简体";
                    break;
            }
        },
        // 头部动态跳转
        jump(item) {
            if (item.editStatus === 0) {
                switch (item.fixedCode || item.name) {
                    case "充值中心":
                        if (this.$common.getUser()) {
                            this.$router.push("/my/finance/deposit");
                        } else {
                            this.$message.error(this.$t("vip.gotologin"));
                        }
                        break;
                    case "合作伙伴":
                        this.$router.push("/agent");
                        break;
                    case "APP下载":
                        this.$router.push("/app");
                        break;
                }
            } else {
                // if (this.$common.getUser()) {
                switch (item.jumpType) {
                    case 0: //路径
                        if (item.openType === 0) {
                            window.open(item.jumpContent, "_self");
                        } else {
                            window.open(item.jumpContent, "_blank");
                        }
                        break;
                    case 1: //公告(打开的是公告详情)
                        // eslint-disable-next-line no-case-declarations
                        if (!this.$common.getUser()) {
                            this.$message.warning(
                                this.$t("enterGame.pleaseLogin")
                            );
                            return;
                        }
                        if (item.jumpContent) {
                            this.$router.push("/my/service/notice");
                            let items = {
                                id: item.jumpContent
                            };
                            this.$store.commit(
                                "showSwiperNoticeDetail",
                                items
                            );
                        }
                        break;
                    case 2: //活动(打开的是优惠活动详情)
                        // eslint-disable-next-line no-case-declarations
                        this.$router.push({
                            //从活动列表进入
                            path: "/discount",
                            query: {
                                id: item.jumpContent
                            }
                        });
                        break;
                    case 3: //专题活动(打开的是限时优惠详情)
                        this.$refs.openSignin.openSignin(item.jumpContent);
                        break;
                    case 4: //游戏
                        if (!this.$common.getUser()) {
                            this.$message.warning(
                                this.$t("vip.gotologin")
                            );
                            return;
                        }
                        let that = this;
                        var issafariBrowser =
                            /Safari/.test(navigator.userAgent) &&
                            !/Chrome/.test(navigator.userAgent);

                        that.tenantId = that.$common.getUser().tenant_id;
                        that.username = that.$common.getUser().username;
                        that.uid = that.$common.getUser().user_id;
                        let data = {
                            tenantId: that.tenantId,
                            username: that.username,
                            gameId: item.jumpContent,
                            clientIp: that.$config.clientIp,
                            memberId: that.uid,
                            terminalType: 1
                        };
                        that.$common.setGameRequestData(data);
                        that.$http
                            .post(that.$api.getToken, data, true)
                            .then(res => {
                                if (res.code == 0) {
                                    that.gameUrl = res.data;
                                    window.open(that.gameUrl);
                                } else {
                                    if (item.openType === 1) {
                                        window.open("/error.html?type=1");
                                    }
                                    let msg =
                                        that.$t(`errorCode.${res.code}`) +
                                        `(${res.code})` ||
                                        that.$t("errorCode.webDefault");
                                    that.$http.errMsg(msg);
                                }
                            });
                        break;
                    case 7: //站内页
                        if (item.needLogin == 1 && !this.$common.getUser()) {
                            this.$message.error(this.$t("vip.gotologin"));
                            return;
                        }
                        this.$router.push({ path: item.jumpContent })
                        break;
                }
                // } else {
                //     this.$message.error(this.$t("vip.gotologin"));
                //     this.$store.commit("loginNavId", 0);
                //     // showLogin({
                //     //     show: true
                //     // });
                // }
            }
        },
        getGameMenuListData: async function () {
            let self = this;
            const res = await self.$http.get(self.$api.menusList);
            if (res.code == 0) {
                self.getData(res, res.data);
            } else {
                this.$message.error(res.msg);
            }
        },
        getData(res, arr) {
            var arr_dz = [];
            var arr_ty = [];
            var arr_qp = [];
            var arr_cp = [];
            var arr_zhibo = [];
            var arr_dj = [];
            var arr_by = [];

            var that = this;
            arr.forEach(function (item) {
                if (item.nameEn == "CASINO") {
                    //电子游艺
                    arr_dz = that.getNewList(item);
                } else if (item.nameEn == "SPORTS") {
                    //体育
                    arr_ty = that.getNewList(item);
                } else if (item.nameEn == "CARD GAME") {
                    //棋牌 游戏
                    arr_qp = that.getNewList(item);
                } else if (item.nameEn == "LOTTERY") {
                    //彩票游戏
                    arr_cp = that.getNewList(item);
                } else if (item.nameEn == "LIVE CASINO") {
                    //直播
                    arr_zhibo = that.getNewList(item);
                } else if (item.nameEn == "Electronic Sports") {
                    //电竞赛事
                    arr_dj = that.getNewList(item);
                }
            });

            this.list_dz = arr_dz;
            this.list_zb = arr_zhibo;
            this.list_cp = arr_cp;
            var arrs = arr_ty.concat(arr_dj);
            this.list_tydj = arrs;
            this.list_qp = arr_qp;
            this.list_dj = arr_dj;

            // 捕鱼
            this.getFishData();
        },
        saveToDefaut() {
            //保存本地
            var data = {
                by: this.list_by, //捕鱼
                dz: this.list_dz, //电子竞技
                cp: this.list_cp, //彩票
                ty: this.list_tydj, //体育
                qp: this.list_qp, //棋牌
                zb: this.list_zb, //直播
                dj: this.list_dj // 电竞
            };
            this.$common.setGameList(data);

            // var da = this.$common.getGameList()
        },
        getNewList(item) {
            var arr = item.children;
            var arr_new = [];
            for (var i = 0; i < arr.length; i++) {
                var data = arr[i];
                if (true) {
                    data.imgUrl = this.$common.getImgUrl(data.imgUrl);
                    if (data.imgUrl != this.$config.imgHost) {
                        arr_new.push(data);
                    }
                }

                if (data.nameEn == "fishing") {
                    this.fishItem = data;
                }
            }
            return arr_new;
        },
        //捕鱼数据
        getFishData() {
            if (this.fishItem.type == 3) {
                this.getGameByIds();
            } else if (this.fishItem.type == 1) {
                this.getVendorGameData();
            }
        },
        // 获取三级目录
        getVendorGameData: async function (loading) {
            let self = this;
            let datas = {
                currentPage: 1,
                pageSize: 100000,
                gameKindId: self.fishItem.id,
                vendorId: self.fishItem.ids
            };

            const res = await self.$http.post(
                self.$api.vendorGame,
                datas,
                false
            );

            if (res.code == 0) {
                var arr = res.data.list;
                arr.forEach(item => {
                    item.imgUrl = self.$common.getImgUrl(item.imgUrl);
                });
                self.list_by = arr;
                self.saveToDefaut();
            }
        },
        // type   3
        getGameByIds: async function (loading) {
            let self = this;
            let datas = {
                currentPage: 1,
                pageSize: 100000,
                gameKindId: self.fishItem.id,
                ids: self.fishItem.ids
            };
            const res = await self.$http.post(
                self.$api.getGameByIds,
                datas,
                false
            );

            if (res.code == 0) {
                var arr = res.data.list;
                arr.forEach(item => {
                    item.imgUrl = self.$common.getImgUrl(item.pictureUrl);
                });
                self.list_by = arr;
                self.saveToDefaut();
            }
        },
        // async getUserBalance() {
        //     var _this = this;
        //     var res;
        //     let data = {
        //         clientId: this.$common.getUser().tenant_id, //tenant_id
        //         clientIp: this.$config.clientIp,
        //         memberId: this.$common.getUser().user_id, //userid
        //         username: this.$common.getUser().username
        //     };
        //     res = await _this.$http.post(_this.$api.getuserMoney, data);
        //     if (res.code == 0) {
        //         this.balance = res.data.totalBalance;
        //         //余额存本地
        //         this.$common.setUserBalance(res.data);
        //     } else {
        //         //连续刷新不能报错
        //         if (res.code != 10041) {
        //             var msg =
        //                 _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
        //                 _this.$t("errorCode.webDefault");
        //             this.$http.errMsg(msg);
        //         }
        //     }
        // },
        //获取余额
        getGameMoneyList(refour = false) {
            if (this.refreshImgTime) {
                setTimeout(() => {
                    this.refreshImgTime = false;
                }, 10000);
                this.$message.error(this.$t("accountPage.warning"));
                return;
            }
            this.refreshImgTime = true;
            this.refreshImgStart = true;
            let option = {
                clientId: this.$common.getUser().tenant_id, //tenant_id
                clientIp: "192.168.1.1",
                memberId: this.$common.getUser().user_id, //userid
                username: this.$common.getUser().username
            };
            this.$http
                .post(this.$api.getGameMoneyList, option, true)
                .then(res => {
                    this.refreshImgStart = false;
                    if (res.code == 0 && res.data) {
                        this.$common.setUserBalance(res.data);
                        this.$store.commit("updataUserInfo", res.data);
                        if (refour) {
                            this.$message.success(
                                this.$t("accountPage.Refresh")
                            );
                        }
                    }
                });
        },
        onbackFan() {
            this.getuserFanshui();
        },
        // 获取返利
        getuserFanshui(type) {
            this.$http
                .get(
                    this.$api.getRebateAmount +
                    this.$cache.get("set_user").user_id
                )
                .then(res => {
                    if (res.code == 0) {
                        this.userfan = res.data;
                        if (type) {
                            this.$message({
                                message: this.$t("myPage.success"),
                                type: "success"
                            });
                        }
                    } else {
                        if (type) {
                            this.$message({
                                message: this.$t("myPage.failure"),
                                type: "warning"
                            });
                        }
                    }
                });
        },
        toPage(type) {
            // 0:首页，1视讯直播，2电子游艺 3体育/竞技 4棋牌 5彩票 6 捕鱼 7优惠 8客服
            this.activeIndex = type;
            switch (type) {
                case 0:
                    this.$router.push({
                        path: "/home"
                    });
                    break;
                case 1:
                    this.$router.push({
                        path: "/live"
                    });
                    break;
                case 2:
                    this.$router.push({
                        path: "/egame"
                    });
                    break;
                case 3:
                    this.$router.push({
                        path: "/sport"
                    });
                    break;
                case 4:
                    this.$router.push({
                        path: "/chess"
                    });
                    break;
                case 5:
                    this.$router.push({
                        path: "/lottery"
                    });
                    break;
                case 6:
                    this.$router.push({
                        path: "/fish"
                    });
                    break;
                case 7:
                    this.$router.push({
                        path: "/discount"
                    });
                    break;
                case 8:
                    window.open(this.$common.getCustomerService(), "_blank");
                    break;
                case 9:
                    this.$router.push({
                        path: "/cooperation"
                    });
                    break;
            }
        },
        logoGo(type) {
            switch (type) {
                case 2:
                    if (!this.$common.getUser()) {
                        this.$message.warning("请先进行登录");
                        return;
                    }
                    this.$router.push({ name: "tradingRecord", params: { id: 4 } })
                    break;
                case 3:
                    this.$router.push({
                        path: "/discount"
                    });
                    break;
                case 4:
                    this.$router.push({
                        path: "/agent"
                    });
                    break;
                case 5:
                    window.open(this.$common.getCustomerService(), "_blank");
                    break;
                case 6:
                    this.$router.push({
                        path: "/app"
                    });
                    break;
            }
        },
        gotoLogin() {
            showLogin({
                show: true
            });
        },
        gotoRegister() {
            this.$router.push("/register");
        },
        async logout() {
            var _this = this;
            if (this.$store.state.token) {
                //手动点击退出
                var res = await _this.$http.delete(_this.$api.logout);
                if (res) {
                    //清除token
                    setTimeout(function () {
                        _this.isLogin = false;
                        _this.$common.clearToken();
                        //首页
                        _this.$router.push("/");
                    }, 200);
                }
            } else {
                //账号在其他地方登陆，被动掉线
                _this.$router.push("/");
            }
        },

        handleScroll(e) {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.top_side = scrollTop + 120;
        },
        //过滤数据
        filterNumber(num) {
            if (num == 0) {
                return "0.00";
            } else {
                return (num * 1).toFixed(2);
            }
        },
        openUrl(e) {
            this.$router.push({
                path: e
            });
        },
        //打开积分商城
        openShop(type) {
            if (!this.$common.getUser()) {
                this.$message({
                    message: "请先登录",
                    type: "warning"
                });
                return;
            }
            // this.activeIndex = 10;
            var obj = {};
            obj.host = this.$common.getHost();
            obj.clientCode = window.clientCode;
            obj.clientItem = window.childCode;
            obj.language = this.$common.getLocale();
            obj.theme = window.theme;
            obj.projectImgUrl = window.projectImgUrl;

            let userInfo = this.$common.getUser();
            obj.userId = userInfo && userInfo.user_id;
            obj.token =
                userInfo && userInfo.token_type + " " + userInfo.access_token;
            obj.showdialog = type; //是否点击签到
            var str = JSON.stringify(obj);
            str = window.btoa(str);
            var url = this.$config.customerServiceUrl + "/mall/pc?s=" + str;
            window.open(url, "_blank");
        },
        getshopName() {
            this.$http.get(this.$api.getClientMall).then(res => {
                if (res.code == 0) {
                    this.shopName = res.data.name;
                }
            });
        }
    },
    watch: {
        $route: {
            handler: function (newVal, oldVal) {
                switch (newVal.path) {
                    case "/home":
                        this.activeIndex = 0;
                        break;
                    case "/live":
                        this.activeIndex = 1;
                        break;
                    case "/egame":
                        this.activeIndex = 2;
                        break;
                    case "/sport":
                        this.activeIndex = 3;
                        break;
                    case "/chess":
                        this.activeIndex = 4;
                        break;
                    case "/lottery":
                        this.activeIndex = 5;
                        break;
                    case "/fish":
                        this.activeIndex = 6;
                        break;
                    case "/discount":
                        this.activeIndex = 7;
                        break;
                    case "/app":
                        this.activeIndex = 8;
                        break;
                    case "/cooperation":
                        this.activeIndex = 9;
                        break;
                }
            },
            deep: true,
            immediate: true
        },
        "$store.state.token"(n) {
            // 监听token，判断是否登录
            this.isLogin = !!n;
        },
        isLogin(n) {
            var _this = this;
            if (n) {
                // 登录
                // this.getuserFanshui();
            } else {
                this.logout();
            }
        }
    }
};
</script>

<style>
#warp {
    /* padding-top: 179px; */
    position: relative;
}

#warp .rightbar-left {
    position: absolute;
    left: 15px;
    transition: all 0.5s;
    z-index: 999;
}

#warp .rightbar-right {
    position: absolute;
    right: 15px;
    transition: all 0.5s;
    z-index: 999;
}

.header {
    display: flex;
    justify-content: space-between;
}

.headerConfiguration li {
    position: relative;
}

.headerConfiguration li+li:before {
    content: '|';
    padding: 0 10px;
    color: #fff;
    font-size: 14px;
}

.headerConfiguration li span {
    font-weight: 400;
    cursor: pointer;
}

.headerConfiguration li i {
    position: absolute;
    width: 496px;
    height: 0;
    z-index: 9999;
    left: -200px;
    top: 29px;
    transition: all .3s;
}

.headerConfiguration li:hover i {
    height: 407px;
}

.language {
    cursor: pointer;
    margin: 0 8px;
}

.popup-list {
    position: absolute;
    top: 90px;
    left: -48px;
    width: 400px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, .9);
    display: none;
    transition: all 0.5s;
    z-index: 9999;
}

.popup-list .popup-top {
    height: 20px;
    background: url('../../assets/images/amjs/nav_top.png');
}

.popup-list .popup-cont {
    width: 355px;
    padding-left: 40px;
    display: flex;
    flex-wrap: wrap;
}

.popup-list .popup-cont .popup-item {
    width: 78px;
    margin-right: 40px;
    margin-bottom: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: #fff;
}

.popup-list .popup-cont .popup-item .popup-icon {
    width: 78px;
    height: 78px;
    margin-bottom: 5px;
    background-image: url('../../assets/images/amjs/join.png');
    background-repeat: no-repeat;
    background-position: center top;
}

.popup-list .popup-cont .popup-item.fs .popup-icon {
    background-image: url('../../assets/images/amjs/anytime.png');
}

.popup-list .popup-cont .popup-item.zq .popup-icon {
    background-image: url('../../assets/images/amjs/promotion.png');
}

.popup-list .popup-cont .popup-item.lr .popup-icon {
    background-image: url('../../assets/images/amjs/browser.png');
}

.popup-list .popup-cont .popup-item.kf .popup-icon {
    background-image: url('../../assets/images/amjs/service1.png');
}

.popup-list .popup-cont .popup-item.xz .popup-icon {
    background-image: url('../../assets/images/amjs/app.png');
}

.popup-list .popup-cont .popup-item:hover .popup-icon {
    background-position: center bottom;
}

.popup-list .popup-cont .popup-item:hover span {
    color: #FFD832;
}

.navChange ul.nav li.logo:hover .popup-list {
    display: block;
}

#warp .heade .heade_1.new-login {
    border-bottom: 1px solid #232122;
    padding: 5px 0;
}

.new-login .login-text {
    margin-left: 60px;
    color: #fff383;
    font-size: 22px;
}

/* .new-login .fly-light {
    position: absolute;
    width: 5px;
    height: 100%;
    background-color: gold;
    position: absolute;
    top: 0;
    left: -100px;
    z-index: 9999;
    animation-name: light;
    animation-duration: 6s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
@keyframes light {
  85%   { left: -100px;}
  100% { left: 1300px;}
} */
@media screen and (max-width:1400px) {
    #warp .rightbar-right {
        transform: scale(0.65);
    }
}
</style>
